<template>
  <div class="proxy-page">
    <PageHeader
      title="Datacenter proxies"
      subtitle="Datacenter proxies are no longer available."
    />

    <SectionCard>
      <v-alert
        type="warning"
        prominent
        icon="mdi-alert-circle-outline"
        class="ma-0 proxy-page__alert"
      >
        <h3 class="proxy-page__unavailable-title">
          Datacenter proxies are unavailable
        </h3>
        <p class="proxy-page__unavailable-text">
          Datacenter proxies are no longer offered. Residential proxies are a
          solid alternative: real residential IPs in 100+ countries with
          country, state, and city targeting, sticky sessions, and unlimited
          concurrency. Pricing is bandwidth-based (per GB).
        </p>
        <div class="proxy-page__unavailable-actions">
          <v-btn color="primary" :to="{ name: 'ResidentialProxies' }">
            <v-icon left>mdi-account-network-outline</v-icon>
            Go to residential proxies
          </v-btn>
        </div>
      </v-alert>
    </SectionCard>
  </div>
</template>

<script>
import PageHeader from "@/components/shared/PageHeader";
import SectionCard from "@/components/shared/SectionCard";

export default {
  name: "DatacenterProxies",
  components: { PageHeader, SectionCard },
};
</script>

<style scoped lang="scss">
.proxy-page {
  &__alert {
    background: rgba(226, 120, 47, 0.08) !important;
    border-color: rgba(226, 120, 47, 0.3) !important;
  }

  &__unavailable-title {
    font-size: 18px;
    font-weight: 600;
    color: #0f172a;
    margin: 0 0 8px;
  }

  &__unavailable-text {
    font-size: 14px;
    line-height: 1.55;
    color: rgba(15, 23, 42, 0.72);
    margin: 0 0 16px;
    max-width: 640px;
  }

  &__unavailable-actions {
    display: flex;
    gap: 12px;
  }
}
</style>
